<div class="container">
  <app-product-list
    [fixStatusIn]="[ProductStatus.invited, ProductStatus.notInvited, ProductStatus.approved]"
    [fixPublished]="true"
    [fixAnyVerdict]="!hasVotingPermissions"
    [fixCycle]="'all'"
  >
  </app-product-list>
</div>
